import axios from "axios"
const API_V2 = process.env.REACT_APP_API_V2_HOST

const apiv2Instance = axios.create({
  baseURL: API_V2,
})
apiv2Instance.defaults.timeout = 25000

export default apiv2Instance
